import React  from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useDispatch } from "react-redux";
import { Checkbox, FormControlLabel } from '@mui/material';
import { closeUnitsAndEnumsDialog } from '../state/unitsandenums/actions';
import { closeEnumsDialog } from '../state/enums/actions';
import { closeEnumsGroupDialog } from '../state/enumsgroup/actions';

const UnitsAndEnumsModal = ({
    title,
    open,
    value,
    setFormModalData,
    handleSave
}) => {
    
    const dispatch = useDispatch();
    // Function to set values of the Form Fields
    const changeHandler = (e) => {
        setFormModalData((prevState) =>
        ({...prevState, [e.target.name]: e.target.value }));
    };
        // Function to handle the close of Form popup
    const handleClose = (event, reason) => {
        setFormModalData({
            fileName: '',
            releaseNotes:'',
            isLatest: false
        });
        
        dispatch(closeUnitsAndEnumsDialog());
        dispatch(closeEnumsDialog());
        dispatch(closeEnumsGroupDialog());
    };

    const handleCheckBox = (e) => {
        setFormModalData((prevState) => ({...prevState, "isLatest": e.target.checked}));
    };

    return (
        <Dialog fullWidth maxWidth="sm" open={open}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers> 
                <TextField 
                    label="Save as" 
                    id="fileName" 
                    name="fileName"
                    fullWidth
                    value={value.fileName}
                    onChange={changeHandler}
                    error={value.fileName === ""}
                    helperText={value.fileName === "" ? "Required Field!" : " "}
                /> 
                <TextField 
                    label="Release Notes" 
                    id="releaseNotes" 
                    name="releaseNotes"
                    multiline
                    rows={4}
                    fullWidth
                    value={value.releaseNotes}
                    onChange={changeHandler}
                    error={value.releaseNotes === ""}
                    helperText={value.releaseNotes === "" ? "Required Field!" : " "}
                /> 
                <FormControlLabel
                    control={ <Checkbox checked={value.isLatest} onChange={handleCheckBox} />}
                    label="Mark as Latest"
                    labelPlacement="start"
                    name="isLatest"
                />
            </DialogContent>
            <DialogActions>
                <Button  variant="contained"
                    size="medium"
                    color="primary" 
                    onClick={handleSave}
                >Submit</Button>
                <Button  variant="contained"
                    size="medium"
                    color="error" onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}

export default UnitsAndEnumsModal
